"use client";

import React from "react";
import { TherapistCard } from "./therapist-card";

export interface Therapist {
  id: string;
  firstName: string;
  lastName: string;
  credential: string;
  profileImage: string;
  therapistTier?: "resident" | "associate";
  acceptingClients: boolean;
  waitlistAvailable?: boolean;
  acceptingFor?: string[];
}

export interface TherapistGridProps {
  therapists: Therapist[];
  loading?: boolean;
  onTherapistClick?: (therapist: Therapist) => void;
}

export function TherapistGrid({ therapists, loading = false, onTherapistClick }: TherapistGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="bg-gray-100 rounded-2xl h-[400px] animate-pulse" />
        ))}
      </div>
    );
  }

  if (therapists.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-12 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full mx-auto mb-4 flex items-center justify-center">
          <svg className="w-8 h-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">No matches found</h3>
        <p className="text-gray-600 mb-6">Try adjusting your filters to see more therapists</p>
        <button 
          onClick={() => window.location.href = '/quiz'}
          className="text-primary-600 hover:text-primary-700 font-medium"
        >
          Take our matching quiz instead
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap justify-center gap-6">
      {therapists.map((therapist) => (
        <TherapistCard
          key={therapist.id}
          {...therapist}
          onClick={() => onTherapistClick?.(therapist)}
        />
      ))}
    </div>
  );
}